export const selectBestFitSpreadData = (state) =>
  state.capture.bestFitSpread.data;

export const selectBestFitSpreadLoading = (state) =>
  state.capture.bestFitSpread.isLoading;

export const selectBestFitSpreadError = (state) =>
  state.capture.bestFitSpread.error;
